import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024a512 512 0 1 1 512-512 512.576 512.576 0 0 1-512 512z m0-960a448 448 0 1 0 448 448A448.512 448.512 0 0 0 512 64z m224 506.72l-275.2 148.8a85.088 85.088 0 0 1-40.32 10.752A68.096 68.096 0 0 1 352 658.016v-292a68.096 68.096 0 0 1 68.352-72.288 85.056 85.056 0 0 1 40.416 10.816l273.888 148.704a69.28 69.28 0 0 1 40.576 59.456A67.2 67.2 0 0 1 736 570.72z m-32-61.28l-273.888-148.672a21.056 21.056 0 0 0-9.824-3.2c-1.728 0-4.352 0-4.352 8.288v292c0 8.288 2.592 8.288 4.352 8.288a20.992 20.992 0 0 0 9.792-3.008l275.2-148.768a29.44 29.44 0 0 0 3.2-2.016 34.784 34.784 0 0 0-4.48-2.912z\" p-id=\"4527\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play.svg
// module id = ufmG
// module chunks = 25